import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EntityTypeEnum } from '@app/core/enums/entity-type.enum';
import { Equipment, EquipmentInput } from '@app/core/model/entities/equipments/equipment';
import {
  EquipmentCreateModalComponent
} from '@app/features/main/views/equipments/equipments-inventory/modals/equipment-create-modal/equipment-create-modal.component';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

@Component({
  templateUrl: './equipment-equipment-create-modal.component.html',
  standalone: false
})
export class EquipmentEquipmentCreateModalComponent extends EquipmentCreateModalComponent implements OnInit {
  private equipment = inject<{ equipment: Equipment }>(MAT_DIALOG_DATA).equipment;
  public formId: string = 'equipment_equipment_creation_dialog';
  private translate = inject(TranslateService);

  /**
   * Initialise missing required fields.
   */
  public ngOnInit(): void {
    super.ngOnInit();
    const defaultMissingRequiredFields = [{code: 'equipmentId', label: this.translate.instant('LABEL.EQUIPMENT')}]
      .filter(({code}) => !this.accessManager.hasFieldWriteOnCreateAccess(code, EntityTypeEnum.EQUIPMENT));
    this.missingRequiredFields$ = this.missingRequiredFields$.pipe(
      map(fields => fields.concat(defaultMissingRequiredFields)),
    );
  }

  /**
   * Data from the filled form.
   * @return Equipment data.
   */
  public getGeneratedObject(): EquipmentInput {
    const input = super.getGeneratedObject();

    return {
      ...input,
      assetId: this.equipment.assetId,
      equipmentIds: [this.equipment.id]
    };
  }
}
